export default __webpack_public_path__ + "static/media/light-green-ball.85a04808.svg";